import React from 'react'
import { Card, Typography, Chip, Box, } from "@mui/material";
import RankedKeywordssvg from "../NavBar/Asset/esocardicon/FileAccessibilityReport/Score.svg";


// export default function Commoncard({ title, value, iconSrc, altText, nonclikable }) {
export default function Commoncard({ item }) {

    const cardColors = [
        {
            iconColor: "#ff6600",
            bgColor: "#fff4e6"
        },
        {
            iconColor: "#ff6600",
            bgColor: "#fff4e6"
        },
        {
            iconColor: "#0b7dda",
            bgColor: "#e6f1ff"
        },
        {
            iconColor: "#7c3aed",
            bgColor: "#f3e8ff"
        },
        {
            iconColor: "#059669",
            bgColor: "#d1fae5"
        }
    ]

    const noCardActivation = !item?.id && !item?.activeValue ? true : false;

    return (
        // <div className="common-card-wrapper-style cardactivecontainer" style={{cursor: nonclikable ? 'default' : 'pointer' }} >
        //     <div className="common-card-icon-container">
        //         <div className="common-card-icons">
        //             <img src={iconSrc} className="common-card-icon-img" alt={altText} />
        //         </div>
        //     </div>
        //     <div className="common-card-subtitle cardcontentactivecontainer">
        //         <span className="common-card-title">{title}</span>
        //         <span className="common-card-value">{value}</span>
        //     </div>
        // </div>


        <>
            <Card onClick={() => item?.handleCardClick ? item?.handleCardClick(item?.route) : null}
                sx={{
                    borderRadius: "16px",
                    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                    transition: "0.3s",
                    cursor: item?.nonclikable ? "default" : "pointer",
                    // border: 1px solid #e0e0e0;
                    "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                    },
                    overflow: "hidden",
                    border: noCardActivation ? "none" : item?.id === item?.activeValue ? "1px solid #ff6600;" : "none"
                }}
            >
                <Box
                    sx={{
                        backgroundColor: cardColors[item?.bgColor || 1].bgColor,
                        p: 2.5,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            fontSize: "2.5rem",
                            background: "linear-gradient(to right, #1f2937, #4b5563)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                            letterSpacing: 1,
                        }}
                    >
                        {item?.value || 0}
                    </Typography>

                    <Box
                        sx={{
                            backgroundColor: cardColors[item?.iconColor || 1].iconColor,
                            color: "#fff",
                            p: 1.5,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "1.5rem",
                        }}
                    >
                        {/* {icon} */}
                        <img src={item?.iconSrc || RankedKeywordssvg} className="card-icon-img" />
                    </Box>
                </Box>

                <Box
                    sx={{
                        background: "#fff",
                        px: 2.5,
                        py: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textTransform: "uppercase",
                    }}
                >
                    <Typography
                        sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                    >
                        {item?.title || ""}
                    </Typography>
                    {item?.badge &&
                        <Chip
                            label={item?.badge || ""}
                            size="small"
                            sx={{
                                backgroundColor: cardColors[item?.iconColor || 1].iconColor,
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "0.7rem",
                                borderRadius: "9999px",
                                px: 1,
                            }}
                        />
                    }
                </Box>
            </Card>
        </>
    )
}
